import React, { createContext, useState } from 'react';

interface LanguageContextProps {
  language: string;
  setLanguage: (lang: string) => void;
}

export const LanguageContext = createContext<LanguageContextProps>({
  language: 'bg', // Changed default to 'bg'
  setLanguage: () => {},
});

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [language, setLanguage] = useState<string>(() => {
    // First check sessionStorage
    const savedLanguage = sessionStorage.getItem('language');
    if (savedLanguage) {
      return savedLanguage;
    }

    // Always default to 'bg' instead of checking browser language
    sessionStorage.setItem('language', 'bg');
    return 'bg';
  });

  const handleSetLanguage = (lang: string) => {
    setLanguage(lang);
    sessionStorage.setItem('language', lang);
  };

  return (
    <LanguageContext.Provider
      value={{ language, setLanguage: handleSetLanguage }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
